import { IdCursor } from "../events/IdCursor";
import { utilDraw } from "../utils/graphics/utilDraw";
import { utilGrid } from "../utils/grid/utilGrid";
import { utilEnvironment } from "../utils/utilEnvironment";
import { BF2GetExpansionCalloutsIso } from "./BF2GetExpansionCalloutsIso";
import { GetLockedGroundGraphicIso } from "./GetLockedGroundGraphicIso";
var Container = PIXI.Container;
var Graphics = PIXI.Graphics;
var Point = PIXI.Point;
var Polygon = PIXI.Polygon;
export var GetUnlockableGroundGraphicIso = function (data, baseSetup, isDiscount) {
    var container = new Container();
    var sprite = GetLockedGroundGraphicIso(data, baseSetup);
    sprite.tint = 0xffffff;
    container.interactiveChildren = false;
    container.interactive = true;
    container.cursor = IdCursor.Pointer;
    var hitAreaPoints = [
        utilGrid.mapToScreen(0, 0),
        utilGrid.mapToScreen(data.xExtent, 0),
        utilGrid.mapToScreen(data.xExtent, data.yExtent),
        utilGrid.mapToScreen(0, data.yExtent),
        utilGrid.mapToScreen(0, 0),
    ].map(function (p) { return new Point(p.x, p.y); });
    container.hitArea = new Polygon(hitAreaPoints);
    container.addChild(sprite);
    // Debug
    if (utilEnvironment.isDevelopment()) {
        container.addChild(utilDraw.drawShape(new Graphics(), {
            area: 1,
            borderAlpha: 1,
            borderColor: 0x7e00ff,
            borderWidth: 1,
            points: hitAreaPoints.map(function (p) { return [p.x, p.y]; }),
        }));
    }
    // TODO: add buy sign after icons are in game
    var displayCallout = BF2GetExpansionCalloutsIso(data, isDiscount);
    if (displayCallout !== undefined) {
        container.addChild(displayCallout);
    }
    return container;
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/GetUnlockableGroundGraphicIso.ts
// module id = 2220
// module chunks = 3